import { coreMessages, type AppLocale } from './base-messages';

export const ru: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: 'Операции с данными',
    operationExportExcel: 'Скачать Excel',
    operationDownloadTemplate: 'Скачать шаблон',
    operationUploadTemplate: 'Загрузить шаблон',
    operationImportHistory: 'История импорта',
    operationFieldDictionary: 'Словарь полей',
    operationUnsupported: 'Эта таблица не поддерживает эту операцию.',
    operationNoPermission: 'У вас нет прав для этой операции.',
    operationNotReady: 'Эта операция ещё не готова.',
    customFieldColumnsSectionLabel: 'Пользовательские поля',
    importModalTitle: 'Загрузить шаблон',
    importChooseFile: 'Выберите CSV-файл',
    importChooseFileHint: 'Заполните и загрузите шаблон, скачанный из этой таблицы.',
    importNoFile: 'Файл не выбран.',
    importSummary: 'Сводка импорта',
    importReadyRows: 'Готовые строки',
    importErrorRows: 'Строки с ошибками',
    importWarnings: 'Предупреждения',
    importUnknownHeaders: 'Неизвестные столбцы',
    importMissingRequiredHeaders: 'Отсутствуют обязательные столбцы',
    importPreview: 'Предпросмотр',
    importSubmit: 'Начать импорт',
    importCancel: 'Отмена',
    importParsing: 'Чтение файла...',
    importSubmitting: 'Импорт выполняется...',
    importNoValidRows: 'Нет допустимых строк для импорта.',
    importFailed: 'Импорт не выполнен.',
    importSucceeded: 'Импорт завершён.',
    operationExportCsv: 'Скачать CSV',
    operationExportPdf: 'Скачать PDF',
    operationNoRows: 'Нет видимых строк для экспорта.',
    importUnknownHeader: 'Неизвестный столбец: {header}',
    importMissingRequiredHeader: 'Отсутствует обязательный столбец: {header}',
    importRequiredCell: 'Поле {header} обязательно.',
    importMaxRowsExceeded: 'В файле больше {maxRows} строк; обработаны только первые {maxRows}.',
    refreshLabel: 'Обновить',
    focusModeEnterLabel: 'Сфокусировать таблицу',
    focusModeFullscreenLabel: 'Открыть на весь экран',
    focusModeExitLabel: 'Выйти из фокуса таблицы',
    horizontalScrollLabel: 'Прокрутить столбцы таблицы',
    selectionModeLabel: 'Выбрать строки',
    selectAllRowsLabel: 'Выбрать все строки',
    selectRowLabel: 'Выбрать строку',
    bulkSelectedLabel: 'Выбрано: {count}',
    bulkActionsLabel: 'Массовые действия',
    tableSettingsLabel: 'Настройки таблицы',
    appearanceSectionLabel: 'Внешний вид',
    columnsSectionLabel: 'Столбцы',
    rowActionsLabel: 'Действия со строкой',
  },
  passwordReset: {
    title: 'Задать новый пароль',
    description: 'Выберите надёжный новый пароль, известный только вам.',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите новый пароль',
    passwordHelp: 'Используйте не менее 12 символов и как минимум три типа: строчные, прописные, цифры и специальные символы.',
    mismatch: 'Пароли не совпадают.',
    invalidLink: 'Ссылка для сброса пароля отсутствует, недействительна или истекла.',
    submit: 'Обновить пароль',
    submitting: 'Пароль обновляется...',
    success: 'Пароль обновлён. Теперь вы можете войти с новым паролем.',
    backToLogin: 'Вернуться ко входу',
    requestTitle: 'Отправить ссылку для сброса пароля',
    requestDescription: 'Одноразовая ссылка, действующая 30 минут, будет отправлена на зарегистрированный адрес пользователя. Текущий пароль не изменится до использования ссылки.',
    requestSend: 'Отправить ссылку',
    requestSending: 'Отправка...',
    requestSuccess: 'Ссылка для сброса пароля принята к отправке.',
    requestError: 'Не удалось отправить ссылку для сброса пароля.',
    selfServiceOpen: 'Забыли пароль',
    selfServiceTitle: 'Восстановление пароля',
    selfServiceDescription: 'Введите адрес электронной почты корпоративной учетной записи. При совпадении будет отправлена одноразовая ссылка, действующая 30 минут.',
    selfServiceEmailLabel: 'Электронная почта',
    selfServiceSubmit: 'Запросить ссылку',
    selfServiceSubmitting: 'Отправка запроса...',
    selfServiceAcknowledgement: 'Если этот адрес зарегистрирован, будет отправлена ссылка для сброса. Проверьте входящие и папку «Спам».',
    selfServiceClose: 'Закрыть',
    selfServiceCancel: 'Отмена',
    selfServiceError: 'Не удалось выполнить запрос. Повторите попытку позже.',
    selfServiceRateLimited: 'Слишком много запросов. Повторите попытку позже.',
  },
  relationshipGraph: {
    sourceColumn: 'Источник',
    relationshipColumn: 'Связь',
    targetColumn: 'Связанная запись',
    showDetails: 'Показать подробности',
    hideDetails: 'Скрыть подробности',
    controlsLabel: 'Управление картой',
    title: 'Карта связей',
    diagramLabel: 'Связи записи',
    diagramHelp: 'Выберите карточку для просмотра сохранённых связей.',
    detailsTitle: 'Сведения о записи',
    connectionsTitle: 'Связи',
    noConnections: 'Нет связей',
    loading: 'Загрузка связей…',
    forbidden: 'У вас нет доступа к этим связям.',
    error: 'Не удалось загрузить связи. Закройте и повторите попытку.',
    empty: 'У этой записи нет доступных для отображения связей.',
    invalid: 'Не удалось проверить связи. Закройте и повторите попытку.',
    close: 'Закрыть карту связей',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    fitView: 'Вместить карту',
  },
  permissionPicker: {
    application: 'Приложение',
    module: 'Модуль',
    action: 'Действие',
    permissions: 'Права',
    description: 'Описание',
    selection: 'Выбор',
    sharedPermissions: 'Общие разрешения',
    selectedPermissions: 'Выбрано разрешений: {count}',
    selectedOnly: 'Только выбранные',
    unselectedOnly: 'Только невыбранные',
    selectedFirst: 'Сначала выбранные',
    noPermissions: 'Нет прав',
  },
  errors: {
    ...coreMessages.errors,
    unknown: 'Произошла неизвестная ошибка',
    network: 'Не удалось подключиться к серверу. Проверьте интернет-соединение.',
    timeout: 'Время ожидания истекло. Попробуйте ещё раз.',
    badRequest: 'Неверный запрос',
    unauthorized: 'Сессия истекла. Войдите заново.',
    forbidden: 'Нет прав для этого действия.',
    notFound: 'Запрашиваемый ресурс не найден',
    tooManyRequests: 'Слишком много запросов. Попробуйте позже.',
    internalServerError: 'Ошибка сервера. Попробуйте позже.',
    badGateway: 'Сервер временно недоступен',
    serviceUnavailable: 'Сервис временно недоступен',
    gatewayTimeout: 'Сервер не отвечает',
    serverErrorWithStatus: 'Ошибка сервера ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: 'Примечание для разработчика: в локальной разработке это обычно означает, что VPN отключен или ваш IP не разрешен. Проверьте VPN и доступ к базе данных.',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'Не удалось подключиться к серверу. Убедитесь, что сервер запущен ({apiUrl}).',
    backendConnectionErrorProd: 'Не удалось подключиться к серверу. Попробуйте позже.',
    systemUpdating: 'Обновление системы...',
    serverConfiguring: 'Настройка сервера, пожалуйста, подождите...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: 'Выбрать',
    cancel: 'Отмена',
    save: 'Сохранить',
    saving: 'Сохранение...',
    edit: 'Редактировать',
    view: 'Просмотр',
    copy: 'Копировать',
    delete: 'Удалить',
    appLauncher: 'Приложения',
    allApps: 'Все приложения',
    loading: 'Загрузка...',
    noData: 'Нет данных',
    code: 'Код',
    profileMenu: 'Меню профиля',
    selectLanguage: 'Выберите язык',
    perPage: 'На странице',
    firstPage: 'Первая страница',
    previousPage: 'Предыдущая',
    nextPage: 'Следующая',
    lastPage: 'Последняя страница',
    pleaseWait: 'Пожалуйста, подождите',
    migrationDescription: 'Выполняется обновление базы данных. Это может занять несколько секунд.',
    changeText: 'Изменить',
    deleteLogo: 'Удалить логотип',
    logoUploadHint: 'Макс. размер: 5 МБ. Форматы: JPEG, PNG, GIF, WebP',
    deleteAvatar: 'Удалить фото профиля',
    avatarUploadHint: 'Макс. 5 МБ. JPEG, PNG, GIF, WebP.',
    newRecord: 'Новая запись',
    noPermission: 'Нет разрешения',
    searchPlaceholder: 'Поиск...',
    allStatuses: 'Все статусы',
    active: 'Активен',
    inactive: 'Неактивен',
    clearFilters: 'Сбросить фильтры',
    all: 'Все',
    clickToChangeStatus: 'Нажмите для изменения статуса',
    noChangePermission: 'У вас нет прав для изменения статуса',
    statusDistribution: 'Распределение статуса',
    hide: 'Скрыть',
    show: 'Показать',
    companies: 'Companies',
    adminConsole: 'Консоль администратора',
    manageAccount: 'Управление аккаунтом',
    manageYourAccount: 'Управление аккаунтом',
    notificationsTitle: 'Уведомления',
    notificationsUnread: 'непрочитанные',
    notificationsTypesMuted: 'типы отключены',
    notificationsViewAll: 'Показать все',
    notificationsPreferences: 'Настройки',
    notificationsMutedLabel: 'Отключено',
    notificationsEmpty: 'Нет уведомлений',
    selectAll: 'Выбрать все',
    id: '№',
    remove: 'Убрать',
    syncDeletedResult: '{count} устаревших записей удалено.',
    distributionByTable: 'Распределение по таблице (контекст)',
    distributionByLocale: 'Распределение по языку',
    translationReport: 'Распределение статуса переводов',
    page: 'Страница',
    rows: 'строк',
    actions: 'Действия',
    create: 'Создать',
    search: 'Поиск',
    closeSearch: 'Закрыть поиск',
    help: 'Помощь',
    helpCenter: 'Центр помощи',
    helpAboutPage: 'Об этой странице',
    helpDocumentation: 'Документация',
    helpKeyboardShortcuts: 'Сочетания клавиш',
    helpWhatsNew: 'Что нового',
    helpF1Hint: 'Нажмите F1, чтобы получить помощь по этой странице',
    helpNoDocsForPage: 'Документация для этой страницы пока недоступна',
    aiAssistantTitle: 'ИИ-ассистент QubePro',
    aiAssistantButton: 'ИИ-ассистент',
    aiAssistantUnavailable: 'ИИ-ассистент сейчас недоступен.',
    appearancePreference: 'Предпочтения интерфейса',
    modalControlPlacement: 'Расположение элементов формы',
    modalControlPlacementHint: 'Задаёт положение кнопок закрытия и полноэкранного режима в формах.',
    modalControlPlacementSystem: 'Система (рекомендуется)',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: 'Начать обзор продукта',
      restart: 'Перезапустить обзор продукта',
      navigationTitle: 'Боковое меню и модули',
      navigationDescription: 'Используйте боковое меню для перехода к доступным модулям и страницам и раскрывайте или сворачивайте разделы.',
      appsTitle: 'Приложения',
      appsDescription: 'Открывайте приложения QubePro и переключайтесь между ними здесь.',
      profileTitle: 'Профиль и компания',
      profileDescription: 'Управляйте здесь профилем, выбранной компанией и языковыми настройками.',
      aiTitle: 'QubePro AI',
      aiDescription: 'Откройте ИИ-ассистента QubePro, чтобы получить помощь по текущей странице.',
      helpTitle: 'Центр помощи',
      helpDescription: 'Откройте документацию или перезапустите этот обзор продукта в любое время.',
      next: 'Далее',
      previous: 'Назад',
      done: 'Готово',
      close: 'Закрыть',
      neverShowAgain: 'Больше не показывать автоматически',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: 'Расширения',
    close: 'Закрыть',
    modalFocus: 'Сфокусироваться на форме',
    modalFullscreen: 'На весь экран',
    modalRestore: 'Восстановить размер',
    filterByColumn: 'Фильтр по полю «{column}»',
    formCustomFieldsLoading: 'Загрузка пользовательских полей…',
    formCustomFieldsLoadError: 'Не удалось загрузить пользовательские поля. Повторите попытку перед сохранением, чтобы избежать потери данных.',
    formCustomFieldsRetry: 'Повторить',
    pageUnavailableTitle: 'Не удалось открыть страницу',
    pageUnavailableMessage: 'Можно открыть другую страницу через меню или обновить эту страницу.',
    pageReloadWarning: 'При обновлении несохранённые изменения будут потеряны.',
    allTargetLanguages: 'Все языки (10 языков)',
    darkMode: 'Тёмная тема',
    lightMode: 'Светлая тема',
    errorOccurred: 'Произошла ошибка',
    confirm: 'Подтвердить',
    context: 'Таблица',
    key: 'Колонка',
    originalShort: 'Orig.',
    originalValue: 'Исходное значение',
    locale: 'Язык',
    value: 'Значение',
    status: 'Статус',
    auto: 'Авто',
    manual: 'Вручную',
    manageLocales: 'Управление языками',
    updateUntranslatedFields: 'Синхронизировать новые поля',
    autoTranslate: 'Автоперевод',
    sourceAndTargetMustDiffer: 'Исходный и целевой язык должны отличаться.',
    autoTranslateSuccessCount: 'Автоматически переведено элементов: {count}.',
    syncEntriesResult: 'Синхронизировано {count} новых записей перевода.',
    translated: 'Translated',
    missing: 'Отсутствует',
    autoTranslateScope: 'Область автоматического перевода',
    updateUntranslatedFieldsHint: 'Нажмите «Обновить новые поля» для синхронизации содержимого из этих таблиц.',
    processing: 'Обработка...',
    enterTargetLanguage: 'Выберите целевой язык.',
    sourceLanguage: 'Исходный язык',
    selectLanguagesFirst: 'Сначала выберите языки в управлении языками',
    sourceLanguageLabel: 'Исходный язык (интерфейс)',
    targetLanguage: 'Целевой язык',
    activeLocalesDescription: 'Выберите активные языки. Сохраняется только как настройка.',
    selectSourceLanguageForSync: 'На каком языке содержимое?',
    languageNames: {
      en: 'Английский',
      tr: 'Турецкий',
      de: 'Немецкий',
      fr: 'Французский',
      es: 'Испанский',
      ar: 'Арабский',
      it: 'Итальянский',
      ja: 'Японский',
      zh: 'Китайский',
      ru: 'Русский',
    },
    warning: 'Предупреждение',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'Ошибка входа',
    emailRequired: 'Требуется адрес электронной почты',
    passwordRequired: 'Требуется пароль',
    backendUnavailable: 'Сервер недоступен. Попробуйте позже.',
    backendConnectFailed: 'Не удалось подключиться к серверу. Попробуйте позже.',
    backendConnectFailedDev: 'Не удалось подключиться к серверу. Убедитесь, что сервер запущен ({apiUrl}).',
    emailLabel: 'Email',
    emailPlaceholderFull: 'Введите ваш email',
    passwordLabel: 'Пароль',
    passwordPlaceholderFull: 'Введите пароль',
    hidePassword: 'Скрыть пароль',
    showPassword: 'Показать пароль',
    loggingIn: 'Вход...',
    submitButton: 'Войти',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'Неверный email или пароль. Попробуйте снова.',
      sessionTooLarge: 'Данные сессии слишком велики. Попробуйте войти снова.',
      databaseUnavailable: 'База данных недоступна или требуется настройка. Войдите снова.',
      accountInactive: 'Ваша учётная запись неактивна. Обратитесь к системному администратору.',
      sessionExpired: 'Срок сеанса истёк. Войдите снова.',
      tooManyAttempts: 'Слишком много попыток. Попробуйте позже.',
    },
    featureTitle: "Объедините операционные и финансовые записи",
    featureDescription: "Отслеживайте запасы, закупки, продажи и финансовые записи с QubePro ERP.",
    featureCard1Title: "Товары и запасы",
    featureCard1Description: "Управляйте товарами, складами и движением запасов.",
    featureCard2Title: "Закупки",
    featureCard2Description: "Отслеживайте закупочные документы и заказы.",
    featureCard3Title: "Документы продаж",
    featureCard3Description: "Управляйте заказами на продажу и счетами.",
    featureCard4Title: "Финансовые движения",
    featureCard4Description: "Просматривайте банковские, кассовые и финансовые записи.",
    darkMode: 'Тёмная тема',
    lightMode: 'Светлая тема',
    pleaseWait: 'Пожалуйста, подождите',
    serverConfiguring: 'Настраивается сервер, подождите...',
    dbCreating: 'Создаются база данных и необходимые конфигурации. Это может занять несколько секунд.',
    loginPageTitle: 'Вход',
    languageToggleLabel: 'Язык',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'Панель управления',
    settings: 'Настройки',
    toggleMenu: 'Открыть меню',
    toggleMenuClose: 'Закрыть меню',
    companies: 'Компании',
    logout: 'Выйти',
    activityLogs: 'Журналы активности',
  },
  customFields: {
    title: 'Пользовательские поля',
    newField: 'Новое пользовательское поле',
    editField: 'Редактировать пользовательское поле',
    entityType: 'Тип записи',
    code: 'Код поля',
    label: 'Отображаемое имя',
    codePlaceholder: 'например riskLevel',
    labelPlaceholder: 'например Спецкод 1',
    dataType: 'Тип данных',
    type: 'Тип',
    scope: 'Область',
    companyId: 'ID компании',
    companySelection: 'Компании',
    companySelectionPlaceholder: 'Пусто = глобально, или выберите компании',
    selectedCompanies: '{{count}} компаний выбрано',
    selectAllCompanies: 'Выбрать все компании',
    sortOrder: 'Порядок',
    required: 'Обязательное',
    searchable: 'Доступно для поиска',
    showInForm: 'Показывать в форме',
    showInList: 'Показывать столбец',
    formTab: 'Вкладка формы',
    formTabSelect: 'Вкладка формы',
    formTabPlaceholder: 'Если пусто, используется вкладка Пользовательские поля',
    defaultCustomTab: 'Пользовательские поля',
    selectEntityTypeFirst: 'Сначала выберите тип',
    newFormTab: 'Новая вкладка',
    tabCode: 'Код вкладки',
    tabName: 'Название вкладки',
    tabCodePlaceholder: 'напр. operations',
    tabNamePlaceholder: 'напр. Операционные данные',
    fieldWidth: 'Разметка строки',
    widthFull: '1 поле в строке',
    widthHalf: '2 поля в строке',
    widthThird: '3 поля в строке',
    widthQuarter: '4 поля в строке',
    systemField: 'Системное поле',
    description: 'Описание',
    options: 'Параметры',
    optionsPlaceholder: 'Каждая строка: code:Метка\nПример: draft:Черновик\nили просто Черновик',
    defaultValue: 'Значение по умолчанию',
    statusDistributionTitle: 'Распределение статусов {{title}}',
    emptyMessage: 'Пользовательские поля еще не заданы.',
    globalScope: 'Глобально',
    companyScope: 'Компания {{id}}',
    deleteSelected: 'Удалить выбранные',
    deleteSelectedMessage: 'Будет удалено пользовательских полей: {{count}}. Это действие нельзя отменить.',
    formDesigner: 'Дизайн формы',
    formDesignerTitle: 'Дизайн формы пользовательских полей',
    formDesignerEntityType: 'Тип записи для настройки',
    formDesignerAllTabs: 'Все',
    formDesignerEmpty: 'Для этого типа записи нет пользовательских полей.',
    formDesignerOriginalNotice: 'Исходные поля формы сохраняются; этот экран управляет вкладками, порядком и расположением пользовательских полей.',
    formDesignerSave: 'Сохранить дизайн',
    formDesignerSaved: 'Дизайн формы сохранен.',
    formDesignerMoveUp: 'Переместить вверх',
    formDesignerMoveDown: 'Переместить вниз',
    formDesignerFieldSettings: 'Расположение поля',
    formDesignerQuickSave: 'Сохранить',
    formDesignerEditTab: 'Редактировать вкладку',
    formDesignerDeleteTab: 'Удалить вкладку',
    formDesignerTabEditorTitle: 'Настройки вкладки',
    formDesignerCloseTabEditor: 'Закрыть редактор вкладки',
    dataTypes: {
      text: 'Текст',
      number: 'Число',
      date: 'Дата',
      datetime: 'Дата/время',
      boolean: 'Да/Нет',
      select: 'Выбор',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: 'Журналы активности',
    searchPlaceholder: 'Поиск (сущность, модуль, действие)…',
    allModules: 'Все модули',
    allActions: 'Все действия',
    allSeverity: 'Все уровни важности',
    allApps: 'Все приложения',
    startDate: 'Начальная дата',
    endDate: 'Конечная дата',
    exportCsv: 'Экспорт в CSV',
    total: 'Всего',
    today: 'Сегодня',
    critical: 'Критично',
    warning: 'Предупреждение',
    severityInfo: 'Инфо',
    exportFilenameStem: 'zhurnaly-aktivnosti',
    noLogs: 'Записей активности не найдено.',   system: 'Система',
    field: 'Поле',
    oldValue: 'Старое значение',
    newValue: 'Новое значение',
    ip: 'IP',
    meta: 'Метаданные запроса',
    userAgent: 'User-Agent',
    entity: 'Сущность',
    severityCol: 'Важность',
    userCol: 'Пользователь',
    actionCol: 'Действие',
    moduleCol: 'Модуль',
    dateCol: 'Дата',
    appCol: 'Приложение',
    overviewTitle: 'Обзор',
    severityChart: 'Распределение по важности',
    topModulesChart: 'Крупные модули по объёму',
    csvId: 'ID',
    csvDate: 'Дата',
    csvUser: 'Пользователь',
    csvAction: 'Действие',
    csvModule: 'Модуль',
    csvEntity: 'Сущность',
    csvSeverity: 'Важность',
    csvIp: 'IP',
    csvApplication: 'Приложение',
    companyCol: 'ID компании',
    allOutcomes: 'Все результаты',
    noLogsDesc: 'Записи появятся здесь после выполнения действий пользователями.',
    entityType: 'Тип записи',
    actorType: 'Тип субъекта',
    outcome: 'Результат',
    successful: 'Успешно',
    failed: 'Ошибка',
    denied: 'Отклонено',
    reason: 'Причина',
    requestId: 'ID запроса',
    correlationId: 'ID корреляции',
    integrity: 'Подтверждение целостности',
    outboxWarning: 'Очередь доставки аудита требует внимания.',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'Уведомления',
    tabPreferences: 'Настройки',
    markAllRead: 'Отметить все как прочитанные',
    notifCount: '{total} уведомлений',
    unreadCount: '{count} непрочитанных',
    loading: 'Загрузка уведомлений...',
    noNotifications: 'Нет уведомлений',    markRead: 'Отметить как прочитанное',
    delete: 'Удалить',   noPreferences: 'Нет настроек',
    noPreferencesDesc: 'Категории уведомлений пока не найдены. Настройки создаются автоматически при получении уведомлений.',
    preferencesHeader: 'Настройки уведомлений в приложении',
    prefItemDesc: 'Получать уведомления этой категории в приложении',
    readDistribution: 'Распределение по статусу прочтения',
    readStatusLabel: 'Статус прочтения',
    filterAll: 'Все',
    filterUnread: 'Непрочитанные',
    filterRead: 'Прочитанные',    colType: 'Тип',
    colTitle: 'Заголовок',
    colMessage: 'Сообщение',
    colDate: 'Дата',
    colRead: 'Статус',
    statusUnread: 'Непрочитано',
    statusRead: 'Прочитано',
    searchNotifications: 'Поиск по заголовку или сообщению…',
  },
};
